import React from 'react'
import { ITileData } from 'apps/placeme/src/features/Analyse/slice/@types/ITileData'
import { Loader } from '@dataplace.ai/ui-components/atoms'
import { potentialLabels } from './resultData/labels'
import WellFitPotentialModelResult from './WellFitPotentialModelResult/WellFitPotentialModelResult'

export interface Location {
  id: number
  address: string
  score: number
}

interface Ranking {
  places: {
    current: number
    lowest: number
  };
  list: Location[]
}

interface AdditionalValues {
  population: {
    '2km': { value: number; chainMeanValue: number }
    '500m': { value: number; chainMeanValue: number }
    '16_34_500m': { value: number; chainMeanValue: number }
    '16_34_2km': { value: number; chainMeanValue: number }
  };
  behavioral: {
    active500m: { value: number; chainMeanValue: number }
    active2km: { value: number; chainMeanValue: number }
  };
  pois: {
    competition2km: { value: number; chainMeanValue: number }
  };
}

export interface WfPotentialModel {
  potentialModel: {
    score: number
    members: number
    additionalValues: AdditionalValues
    influence: {
      population: number
      traffic: number
      tgFitLovers: number
      competitors: number
      citySize: number
    }
    ranking: Ranking
    similarLocations: {
      id: number
      address: string
      score: number
    }[]
  }
}

export interface IWellFitPotentialModelTileData extends ITileData {
  value: WfPotentialModel
}

const WellFitPotentialModel: React.FC<{
  data: IWellFitPotentialModelTileData,
  tileId: string,
}> = ({ data }) => {
  if (data?.loading || !data?.value) return <Loader />

  return (
    <WellFitPotentialModelResult
      data={data.value}
      labels={potentialLabels}
    />
  )
}

export default WellFitPotentialModel
